var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pg-result"
  }, [_c('div', {
    staticClass: "pg-result__box"
  }, [_c('p', {
    staticClass: "pg-result__title",
    class: {
      'pg-result__title--fail': !_vm.ok
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm.message ? _c('p', {
    staticClass: "pg-result__message"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _c('p', {
    staticClass: "pg-result__guide"
  }, [_vm._v(_vm._s(_vm.guide))]), _c('button', {
    staticClass: "pg-result__button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.standalone ? "확인" : "창 닫기"))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }